import Link from "@client/components/site-header/components/logo-link";

interface Props {
  baseUrl?: string;
  children?: React.ReactNode;
  logo?: string;
}

export default function Logo({ baseUrl, children, logo, ...props }: Props) {
  return (
    <div className="site-header__logo" {...props}>
      {children || (
        <Link
          baseUrl={baseUrl}
          style={logo ? { backgroundImage: `url(${logo})` } : undefined}
        />
      )}
    </div>
  );
}
